import { ProviderDto } from './models';

export class ProviderDtoEmpty implements ProviderDto{
  name = '';
  contact = '';
}